var _path, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFooterIcon4(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0.941406H24V24.9414H0V0.941406Z",
    fill: "url(#pattern0)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_2922_2562",
    transform: "scale(0.0416667)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_2922_2562",
    width: 24,
    height: 24,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAAAXNSR0IArs4c6QAAAnJJREFUSEulVdGN2kAQnRFY4vNSQaCDUEGw0O6KP64DUkGggoMKjqvgLhWEfCGvP6CD0EG4CsI3eJlorF1rbGxzUvyDWI/nvTczbxbhA89ut3s4n88jRPzM4UT0fr1eD5PJ5Hjvc2wLSNN0RERPADCqi0PETZZlizagRoA0TedE9OwTnwBgg4g5YyLqe1D+5f8rY8yylkTdYZIkS0Rk5idEXHe73Zc4jhmk9KRp+kREeeImkBsF1tovAPCbkwNArLU+tJXRx+8A4AERY6XUXsbXAXByBplrrV9CsLV2BgBfPdu9MeZHeCfKuddax40Agv1Raz0QyZlhtdFvWutvIuYvqwCAoVRdUmCt/Q4AayJaG2MW/LFn/goAR0ScewVrAOgj4lIpteKzJEme/fuS8hJACCKiWSiBtTawL5j58d3xmCqlHiURSY7PqwqY6awCkPek0+n0x+Pxu08WBqGouVBaKl0JQIxdIVOcvTnnVr1e75Rl2SsRTQGgSBbKK8t2oyBJkiki/pQf8pq4XC6sIjeVeI7OuTi42Fqbq0fEqVLqV4grKfDJeBpOURQNgrm2222/0+mw8Zg1PxtWI1eEtfYPk4ii6JM0ZZ0P8qbKPrQZrTJp7T7g4DAhAHDQWg/vJfcAOftqeW56UDUWIi6UUjzzjY/0iTRnbQ/CoVBxcs4Nm9ax7w2XtO+cG9TFNa5r4cybulaVVs0l5TYCyPGsW8VipR+jKBrWrfPGHgQGvgTsAV7FRT/E9mwt4V0ADhDm40uFjcSq2VT8/9EYs2kbgtY7WTRdXp/huLQ1m0A+BOD9UVyP1X3z3wrE1PCmJXmb3TPiPz0GkShJf6euAAAAAElFTkSuQmCC"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFooterIcon4);
export default __webpack_public_path__ + "static/media/footer-icon4.df6cd92cb638f0de654e9301473f9a0f.svg";
export { ForwardRef as ReactComponent };